var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.TiptapToolbarBtn, {
    attrs: {
      iconClass: "bi-file-earmark-pdf",
      command: _setup.openBrowser,
      "is-active": _vm.isDidLink,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }